import { put, all } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/financials/messages";
import formatList from "./util/formatPayoutsList";

function* payoutToPowurRequest() {
  const { success, data, error } = yield* makeRequest.post("/payouts/powur_payout", {});

  if (success && data) {
    yield all([
      put(actions.setPayoutsList(formatList(data))),
      put(
        actions.newSuccessEvent({
          message: messages.SUCCESS_PAYING_OUT_TO_POWUR,
        }),
      ),
    ]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_PAYING_OUT_TO_POWUR,
    });
  }

  return null;
}

export default payoutToPowurRequest;
